import axios from "axios";
import endpoints from "@/api/endpoints";

export class CompaniesService {
  static __instance = null;

  constructor() {
    if (CompaniesService.__instance) {
      return CompaniesService.__instance;
    }

    CompaniesService.__instance = this;
  }

  /**
   * @typedef {Object} Company
   * @property {number} id - идентификатор компании.
   * @property {string} title - наименование компании.
   * @property {string} href - ссылка для перехода в компанию.
   * @property {boolean} active - статус выбрана/невыбрана.
   */

  /**
   * @return {Promise<Company[]>}
   */
  getCompanies() {
    return new Promise((resolve, reject) => {
      axios
        .get(endpoints.company.list)
        .then(response => {
          if (response.data) {
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  getCompaniesByManager(id) {
    let formData = new FormData();
    formData.append("id", id);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.company.listByManager, formData)
        .then(response => {
          if (response.data) {
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }

  setActiveCompany(id, name) {
    let formData = new FormData();
    formData.append("id", id);

    return new Promise((resolve, reject) => {
      axios
        .post(endpoints.company.setActive, formData)
        .then(response => {
          if (response.data) {
            document.querySelector(
              "#js-select-company-btn span"
            ).innerText = name;
            return resolve(response.data);
          } else return reject("Server error");
        })
        .catch(err => reject(err));
    });
  }
}

export const companiesService = new CompaniesService();
